/* TCR product ontology — "what goes with what".
   Maps a product category to genuinely related categories so the Finder can
   suggest logical next purchases (helmets -> gloves, suits, shields...).
   All affinities are real automotive pairings, no invented relationships.
   Format: { match: [keywords], related: [{label, q}] } — q is the catalog search run on tap. */
window.TCR_ONTOLOGY = [
  { match: ['helmet'],
    related: [
      { label: 'Racing gloves', q: 'racing gloves' },
      { label: 'Racing suits', q: 'racing suit' },
      { label: 'Helmet shields', q: 'helmet shield' },
      { label: 'Racing shoes', q: 'racing shoes' } ] },
  { match: ['brake pad'],
    related: [
      { label: 'Brake rotors', q: 'brake rotors' },
      { label: 'Brake fluid', q: 'brake fluid' },
      { label: 'Brake lines', q: 'brake lines' },
      { label: 'Brake kits', q: 'big brake kit' } ] },
  { match: ['brake rotor', 'rotor'],
    related: [
      { label: 'Brake pads', q: 'brake pads' },
      { label: 'Brake fluid', q: 'brake fluid' },
      { label: 'Calipers', q: 'brake caliper' } ] },
  { match: ['motor oil', 'engine oil'],
    related: [
      { label: 'Oil filters', q: 'oil filter' },
      { label: 'Transmission fluid', q: 'transmission fluid' },
      { label: 'Coolant', q: 'coolant' },
      { label: 'Shop towels', q: 'shop towels' } ] },
  { match: ['oil filter'],
    related: [
      { label: 'Motor oil', q: 'motor oil' },
      { label: 'Air filters', q: 'air filter' },
      { label: 'Drain plugs', q: 'oil drain plug' } ] },
  { match: ['cold air intake'],
    related: [
      { label: 'Air filters', q: 'air filter' },
      { label: 'Exhaust systems', q: 'cat-back exhaust' },
      { label: 'Throttle bodies', q: 'throttle body' } ] },
  { match: ['air filter'],
    related: [
      { label: 'Cold air intakes', q: 'cold air intake' },
      { label: 'Oil filters', q: 'oil filter' },
      { label: 'Cabin filters', q: 'cabin air filter' } ] },
  { match: ['exhaust', 'cat-back', 'muffler'],
    related: [
      { label: 'Headers', q: 'headers' },
      { label: 'Exhaust tips', q: 'exhaust tip' },
      { label: 'Catalytic converters', q: 'catalytic converter' } ] },
  { match: ['header'],
    related: [
      { label: 'Exhaust systems', q: 'cat-back exhaust' },
      { label: 'Header gaskets', q: 'header gasket' },
      { label: 'O2 sensors', q: 'oxygen sensor' } ] },
  { match: ['tonneau'],
    related: [
      { label: 'Bed liners', q: 'bed liner' },
      { label: 'Bed extenders', q: 'bed extender' },
      { label: 'Tailgate seals', q: 'tailgate seal' } ] },
  { match: ['lift kit'],
    related: [
      { label: 'Shocks', q: 'lift shocks' },
      { label: 'Control arms', q: 'control arms' },
      { label: 'Alignment kits', q: 'alignment kit' },
      { label: 'Wheels', q: 'wheels' } ] },
  { match: ['leveling kit'],
    related: [
      { label: 'Shocks', q: 'shocks' },
      { label: 'Lift kits', q: 'lift kit' },
      { label: 'Alignment kits', q: 'alignment kit' } ] },
  { match: ['shock', 'strut', 'coilover'],
    related: [
      { label: 'Lift kits', q: 'lift kit' },
      { label: 'Control arms', q: 'control arms' },
      { label: 'Sway bar links', q: 'sway bar link' } ] },
  { match: ['wheel', 'rim'],
    related: [
      { label: 'Tires', q: 'tires' },
      { label: 'Lug nuts', q: 'lug nuts' },
      { label: 'TPMS sensors', q: 'tpms sensor' } ] },
  { match: ['tire'],
    related: [
      { label: 'Wheels', q: 'wheels' },
      { label: 'TPMS sensors', q: 'tpms sensor' },
      { label: 'Tire repair kits', q: 'tire repair kit' } ] },
  { match: ['led', 'headlight', 'light bar'],
    related: [
      { label: 'Wiring harnesses', q: 'wiring harness' },
      { label: 'Light pods', q: 'led pods' },
      { label: 'Relays', q: 'relay' } ] },
  { match: ['racing seat', 'seat'],
    related: [
      { label: 'Harnesses', q: 'racing harness' },
      { label: 'Seat brackets', q: 'seat bracket' },
      { label: 'Roll bars', q: 'roll bar' } ] },
  { match: ['harness'],
    related: [
      { label: 'Racing seats', q: 'racing seat' },
      { label: 'Roll bars', q: 'roll bar' },
      { label: 'Hans devices', q: 'hans device' } ] },
  { match: ['transmission fluid', 'atf'],
    related: [
      { label: 'Motor oil', q: 'motor oil' },
      { label: 'Transmission filters', q: 'transmission filter' },
      { label: 'Coolant', q: 'coolant' } ] },
  { match: ['coolant', 'antifreeze'],
    related: [
      { label: 'Motor oil', q: 'motor oil' },
      { label: 'Radiator hoses', q: 'radiator hose' },
      { label: 'Thermostats', q: 'thermostat' } ] },
  { match: ['spark plug'],
    related: [
      { label: 'Ignition coils', q: 'ignition coil' },
      { label: 'Plug wires', q: 'spark plug wires' },
      { label: 'Air filters', q: 'air filter' } ] },
  { match: ['fuel pump'],
    related: [
      { label: 'Fuel filters', q: 'fuel filter' },
      { label: 'Fuel injectors', q: 'fuel injector' },
      { label: 'Fuel pressure regulators', q: 'fuel pressure regulator' } ] },
  { match: ['alternator', 'starter'],
    related: [
      { label: 'Batteries', q: 'battery' },
      { label: 'Belts', q: 'serpentine belt' },
      { label: 'Battery cables', q: 'battery cable' } ] },
  { match: ['wiper'],
    related: [
      { label: 'Washer fluid', q: 'washer fluid' },
      { label: 'Headlight restoration', q: 'headlight restoration kit' } ] },
  { match: ['bed liner', 'bed mat'],
    related: [
      { label: 'Tonneau covers', q: 'tonneau cover' },
      { label: 'Bed extenders', q: 'bed extender' } ] },
  { match: ['fender flare'],
    related: [
      { label: 'Mud flaps', q: 'mud flaps' },
      { label: 'Running boards', q: 'running boards' } ] },
  { match: ['running board', 'nerf bar', 'side step'],
    related: [
      { label: 'Fender flares', q: 'fender flares' },
      { label: 'Mud flaps', q: 'mud flaps' } ] },
  { match: ['winch'],
    related: [
      { label: 'Winch mounts', q: 'winch mount' },
      { label: 'Recovery straps', q: 'recovery strap' },
      { label: 'Off-road bumpers', q: 'off-road bumper' } ] },
  { match: ['turbo', 'supercharger', 'boost'],
    related: [
      { label: 'Intercoolers', q: 'intercooler' },
      { label: 'Blow-off valves', q: 'blow off valve' },
      { label: 'Boost gauges', q: 'boost gauge' } ] },
  { match: ['gauge'],
    related: [
      { label: 'Gauge pods', q: 'gauge pod' },
      { label: 'Senders & sensors', q: 'gauge sender' } ] },
  { match: ['caliper'],
    related: [
      { label: 'Brake pads', q: 'brake pads' },
      { label: 'Brake rotors', q: 'brake rotors' },
      { label: 'Brake fluid', q: 'brake fluid' } ] },
  { match: ['master cylinder', 'brake booster'],
    related: [
      { label: 'Brake fluid', q: 'brake fluid' },
      { label: 'Brake lines', q: 'brake lines' },
      { label: 'Calipers', q: 'brake caliper' } ] },
  { match: ['piston', 'piston ring'],
    related: [
      { label: 'Gasket sets', q: 'engine gasket set' },
      { label: 'Bearings', q: 'engine bearings' },
      { label: 'Camshafts', q: 'camshaft' } ] },
  { match: ['camshaft', 'cam'],
    related: [
      { label: 'Lifters', q: 'lifters' },
      { label: 'Timing chains', q: 'timing chain kit' },
      { label: 'Valve springs', q: 'valve springs' } ] },
  { match: ['cylinder head'],
    related: [
      { label: 'Head gaskets', q: 'head gasket' },
      { label: 'Head bolts', q: 'head bolts' },
      { label: 'Camshafts', q: 'camshaft' } ] },
  { match: ['intake manifold'],
    related: [
      { label: 'Throttle bodies', q: 'throttle body' },
      { label: 'Gaskets', q: 'intake gasket' },
      { label: 'Fuel injectors', q: 'fuel injectors' } ] },
  { match: ['gasket'],
    related: [
      { label: 'RTV sealant', q: 'rtv sealant' },
      { label: 'Head bolts', q: 'head bolts' },
      { label: 'Torque wrenches', q: 'torque wrench' } ] },
  { match: ['timing chain', 'timing belt'],
    related: [
      { label: 'Water pumps', q: 'water pump' },
      { label: 'Tensioners', q: 'timing tensioner' },
      { label: 'Front seals', q: 'front main seal' } ] },
  { match: ['motor mount', 'engine mount'],
    related: [
      { label: 'Transmission mounts', q: 'transmission mount' },
      { label: 'Polyurethane bushings', q: 'polyurethane bushings' } ] },
  { match: ['valve cover'],
    related: [
      { label: 'Valve cover gaskets', q: 'valve cover gasket' },
      { label: 'Breathers', q: 'valve cover breather' },
      { label: 'Dress-up bolts', q: 'engine dress up kit' } ] },
  { match: ['oil pan'],
    related: [
      { label: 'Oil pan gaskets', q: 'oil pan gasket' },
      { label: 'Oil pumps', q: 'oil pump' },
      { label: 'Dipsticks', q: 'dipstick' } ] },
  { match: ['clutch'],
    related: [
      { label: 'Flywheels', q: 'flywheel' },
      { label: 'Throwout bearings', q: 'throwout bearing' },
      { label: 'Clutch hydraulics', q: 'clutch master cylinder' } ] },
  { match: ['flywheel'],
    related: [
      { label: 'Clutch kits', q: 'clutch kit' },
      { label: 'Pilot bearings', q: 'pilot bearing' },
      { label: 'Bellhousings', q: 'bellhousing' } ] },
  { match: ['torque converter'],
    related: [
      { label: 'Transmission fluid', q: 'transmission fluid' },
      { label: 'Flexplates', q: 'flexplate' },
      { label: 'Transmission coolers', q: 'transmission cooler' } ] },
  { match: ['differential', 'locker', 'posi'],
    related: [
      { label: 'Gear oil', q: 'gear oil' },
      { label: 'Ring & pinion', q: 'ring and pinion' },
      { label: 'Axle shafts', q: 'axle shafts' } ] },
  { match: ['axle', 'cv joint'],
    related: [
      { label: 'Differentials', q: 'differential' },
      { label: 'Wheel bearings', q: 'wheel bearing' },
      { label: 'U-joints', q: 'u-joint' } ] },
  { match: ['driveshaft'],
    related: [
      { label: 'U-joints', q: 'u-joint' },
      { label: 'Carrier bearings', q: 'driveshaft carrier bearing' } ] },
  { match: ['shifter'],
    related: [
      { label: 'Shift knobs', q: 'shift knob' },
      { label: 'Shift boots', q: 'shift boot' },
      { label: 'Transmission mounts', q: 'transmission mount' } ] },
  { match: ['radiator'],
    related: [
      { label: 'Electric fans', q: 'electric fan' },
      { label: 'Radiator hoses', q: 'radiator hose' },
      { label: 'Coolant', q: 'coolant' } ] },
  { match: ['water pump'],
    related: [
      { label: 'Thermostats', q: 'thermostat' },
      { label: 'Timing kits', q: 'timing chain kit' },
      { label: 'Coolant', q: 'coolant' } ] },
  { match: ['electric fan'],
    related: [
      { label: 'Radiators', q: 'radiator' },
      { label: 'Fan controllers', q: 'fan controller' },
      { label: 'Wiring relays', q: 'relay' } ] },
  { match: ['intercooler'],
    related: [
      { label: 'Turbochargers', q: 'turbocharger' },
      { label: 'Intercooler piping', q: 'intercooler piping' },
      { label: 'Blow-off valves', q: 'blow off valve' } ] },
  { match: ['carburetor', 'carb'],
    related: [
      { label: 'Intake manifolds', q: 'intake manifold' },
      { label: 'Fuel pumps', q: 'fuel pump' },
      { label: 'Air cleaners', q: 'air cleaner' } ] },
  { match: ['fuel injector'],
    related: [
      { label: 'Fuel pumps', q: 'fuel pump' },
      { label: 'Fuel pressure regulators', q: 'fuel pressure regulator' },
      { label: 'O-rings & seals', q: 'injector o-ring' } ] },
  { match: ['fuel filter'],
    related: [
      { label: 'Fuel pumps', q: 'fuel pump' },
      { label: 'Fuel lines', q: 'fuel line' } ] },
  { match: ['fuel cell', 'fuel tank'],
    related: [
      { label: 'Fuel pumps', q: 'fuel pump' },
      { label: 'Fuel level senders', q: 'fuel level sender' } ] },
  { match: ['battery'],
    related: [
      { label: 'Battery cables', q: 'battery cable' },
      { label: 'Alternators', q: 'alternator' },
      { label: 'Battery boxes', q: 'battery box' } ] },
  { match: ['ignition coil', 'coil pack'],
    related: [
      { label: 'Spark plugs', q: 'spark plugs' },
      { label: 'Plug wires', q: 'spark plug wires' } ] },
  { match: ['distributor'],
    related: [
      { label: 'Caps & rotors', q: 'distributor cap' },
      { label: 'Plug wires', q: 'spark plug wires' },
      { label: 'Ignition boxes', q: 'ignition box' } ] },
  { match: ['tie rod', 'pitman arm', 'idler arm'],
    related: [
      { label: 'Ball joints', q: 'ball joints' },
      { label: 'Alignment kits', q: 'alignment kit' },
      { label: 'Steering stabilizers', q: 'steering stabilizer' } ] },
  { match: ['ball joint'],
    related: [
      { label: 'Control arms', q: 'control arms' },
      { label: 'Tie rods', q: 'tie rod ends' } ] },
  { match: ['leaf spring', 'coil spring'],
    related: [
      { label: 'Shocks', q: 'shocks' },
      { label: 'U-bolts', q: 'u-bolts' },
      { label: 'Shackles', q: 'leaf spring shackles' } ] },
  { match: ['bushing'],
    related: [
      { label: 'Control arms', q: 'control arms' },
      { label: 'Sway bar links', q: 'sway bar link' } ] },
  { match: ['sway bar'],
    related: [
      { label: 'End links', q: 'sway bar end links' },
      { label: 'Bushings', q: 'sway bar bushings' } ] },
  { match: ['tuner', 'programmer', 'chip'],
    related: [
      { label: 'Cold air intakes', q: 'cold air intake' },
      { label: 'Exhaust systems', q: 'cat-back exhaust' },
      { label: 'Gauges', q: 'gauges' } ] },
  { match: ['nitrous'],
    related: [
      { label: 'Bottle heaters', q: 'nitrous bottle heater' },
      { label: 'Purge kits', q: 'nitrous purge kit' },
      { label: 'Fuel pumps', q: 'fuel pump' } ] },
  { match: ['throttle body'],
    related: [
      { label: 'Cold air intakes', q: 'cold air intake' },
      { label: 'Intake manifolds', q: 'intake manifold' } ] },
  { match: ['gear oil', 'differential fluid'],
    related: [
      { label: 'Motor oil', q: 'motor oil' },
      { label: 'Gasket maker', q: 'rtv sealant' } ] },
  { match: ['power steering'],
    related: [
      { label: 'Power steering fluid', q: 'power steering fluid' },
      { label: 'Steering boxes', q: 'steering box' } ] },
  { match: ['brake cleaner', 'parts cleaner'],
    related: [
      { label: 'Shop towels', q: 'shop towels' },
      { label: 'Brake pads', q: 'brake pads' },
      { label: 'Gloves', q: 'mechanic gloves' } ] },
  { match: ['jack', 'jack stand'],
    related: [
      { label: 'Creeper', q: 'mechanic creeper' },
      { label: 'Torque wrenches', q: 'torque wrench' },
      { label: 'Wheel chocks', q: 'wheel chocks' } ] },
  { match: ['tool box', 'tool chest'],
    related: [
      { label: 'Socket sets', q: 'socket set' },
      { label: 'Torque wrenches', q: 'torque wrench' } ] },
  { match: ['air compressor'],
    related: [
      { label: 'Impact wrenches', q: 'impact wrench' },
      { label: 'Air hoses', q: 'air hose' } ] },
  { match: ['hitch', 'trailer'],
    related: [
      { label: 'Ball mounts', q: 'ball mount' },
      { label: 'Wiring harnesses', q: 'trailer wiring' },
      { label: 'Weight distribution', q: 'weight distribution hitch' } ] },
  { match: ['skid plate'],
    related: [
      { label: 'Rock sliders', q: 'rock sliders' },
      { label: 'Off-road bumpers', q: 'off-road bumper' } ] },
  { match: ['snorkel'],
    related: [
      { label: 'Air filters', q: 'air filter' },
      { label: 'Skid plates', q: 'skid plates' } ] },
  { match: ['bumper'],
    related: [
      { label: 'Winches', q: 'winch' },
      { label: 'Light bars', q: 'led light bar' },
      { label: 'Tow hooks', q: 'tow hooks' } ] },
  { match: ['grille'],
    related: [
      { label: 'Headlights', q: 'headlights' },
      { label: 'Bumpers', q: 'bumpers' } ] },
  { match: ['hood'],
    related: [
      { label: 'Hood pins', q: 'hood pins' },
      { label: 'Hood struts', q: 'hood struts' } ] },
  { match: ['mirror'],
    related: [
      { label: 'Tow mirrors', q: 'tow mirrors' },
      { label: 'Mirror covers', q: 'mirror covers' } ] },
  { match: ['floor mat', 'floor liner'],
    related: [
      { label: 'Seat covers', q: 'seat covers' },
      { label: 'Cargo liners', q: 'cargo liner' } ] },
  { match: ['seat cover'],
    related: [
      { label: 'Floor mats', q: 'floor mats' },
      { label: 'Steering wheel covers', q: 'steering wheel cover' } ] },
  { match: ['steering wheel'],
    related: [
      { label: 'Hub adapters', q: 'steering wheel hub' },
      { label: 'Quick releases', q: 'steering wheel quick release' } ] },
  { match: ['dash cover', 'dashboard'],
    related: [
      { label: 'Floor mats', q: 'floor mats' },
      { label: 'Gauges', q: 'gauges' } ] },
  { match: ['toolbox', 'bed toolbox', 'chest'],
    related: [
      { label: 'Tonneau covers', q: 'tonneau cover' },
      { label: 'Bed liners', q: 'bed liner' } ] },
  { match: ['fire extinguisher'],
    related: [
      { label: 'Extinguisher mounts', q: 'fire extinguisher mount' },
      { label: 'Roll cages', q: 'roll cage' } ] },
  { match: ['roll cage', 'roll bar'],
    related: [
      { label: 'Harnesses', q: 'racing harness' },
      { label: 'Racing seats', q: 'racing seat' },
      { label: 'Fire extinguishers', q: 'fire extinguisher' } ] },
  { match: ['belt', 'serpentine'],
    related: [
      { label: 'Tensioners', q: 'belt tensioner' },
      { label: 'Idler pulleys', q: 'idler pulley' } ] },
  { match: ['hose'],
    related: [
      { label: 'Clamps', q: 'hose clamps' },
      { label: 'Coolant', q: 'coolant' } ] },
  { match: ['washer fluid', 'rain-x'],
    related: [
      { label: 'Wiper blades', q: 'wiper blades' } ] },
];
